module.exports = __webpack_public_path__ + "img/1.e03f049e.png";